var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0002 15.5V22.1666M20.0002 28.8333H20.0169M17.0669 7.09497L3.0302 30.5283C2.74099 31.0295 2.588 31.5976 2.58644 32.1762C2.58488 32.7549 2.7348 33.3238 3.0213 33.8266C3.3078 34.3293 3.7209 34.7483 4.21952 35.0418C4.71815 35.3354 5.28494 35.4934 5.86353 35.5H33.9385C34.5171 35.4934 35.0839 35.3354 35.5825 35.0418C36.0812 34.7483 36.4943 34.3293 36.7808 33.8266C37.0673 33.3238 37.2172 32.7549 37.2156 32.1762C37.2141 31.5976 37.0611 31.0295 36.7719 30.5283L22.7335 7.09497C22.4379 6.60829 22.022 6.20595 21.5257 5.92674C21.0294 5.64753 20.4696 5.50085 19.9002 5.50085C19.3308 5.50085 18.771 5.64753 18.2747 5.92674C17.7784 6.20595 17.3625 6.60829 17.0669 7.09497Z",
    stroke: "#1957E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.17d2db14bb63590bbb93347dffb8f7e5.svg";
export { ForwardRef as ReactComponent };